module.exports = __webpack_public_path__ + "static/media/Sila.604f18d6.jpg";